function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchHistoryRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 25C5.57 25 4 23.43 4 21.5S5.57 18 7.5 18s3.5 1.57 3.5 3.5S9.43 25 7.5 25zm5.5-3.5a5.5 5.5 0 10-2.448 4.575L14.478 30 16 28.477l-3.925-3.925A5.482 5.482 0 0013 21.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14h-8V7h2v5h6v2zM19 2C12.925 2 8 6.925 8 13c0 .347.021.689.052 1.028C11.93 14.312 15 17.551 15 21.5c0 .566-.07 1.124-.194 1.667A10.94 10.94 0 0019 24c6.075 0 11-4.925 11-11S25.075 2 19 2z",
    fill: props.color
  }));
}

export default SvgIconSearchHistoryRexFilled;